
$_GP._.throttle = function(fn, timeWindow, scope) {
	'use strict';

	timeWindow = timeWindow || (timeWindow = 200);
	var last, deferTimer;

	return function() {
		var context = scope || this;
		var now = new Date().getTime();
		var args = arguments;

		if (last && now < last + timeWindow) {
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function() {
				last = now;
				fn.apply(context, args);
			}, timeWindow);
		}
		else {
			last = now;
			fn.apply(context, args);
		}
	};
};
